import React from "react";
import { strokeToPath } from "./frameGeometry";
import "./FrameAnnotations.css";

const VIEW_W = 1000;

/**
 * Слой поверх кадра: точка (markerPoint, проценты) и рисунок (drawing, доли кадра).
 * frameRect — прямоугольник кадра относительно контейнера плеера (см. useFrameRect).
 * Ничего не перехватывает — pointer-events: none.
 */
const AnnotationOverlay = ({ frameRect, markerPoint, drawing, dimmed = false }) => {
  if (!frameRect || !frameRect.width || !frameRect.height) return null;
  const strokes = (drawing && drawing.strokes) || [];
  const viewH = (VIEW_W * frameRect.height) / frameRect.width;

  return (
    <div
      className={`fa-overlay${dimmed ? " fa-overlay--dimmed" : ""}`}
      style={{
        left: frameRect.left,
        top: frameRect.top,
        width: frameRect.width,
        height: frameRect.height,
      }}
    >
      {strokes.length > 0 && (
        <svg
          className="fa-drawing"
          viewBox={`0 0 ${VIEW_W} ${viewH}`}
          preserveAspectRatio="none"
          width="100%"
          height="100%"
        >
          {strokes.map((s, i) => (
            <path
              key={i}
              d={strokeToPath(s, VIEW_W, viewH)}
              stroke={s.c || "#FF3B30"}
              strokeWidth={(s.w || 0.005) * VIEW_W}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          ))}
        </svg>
      )}
      {markerPoint && (
        <div
          className="fa-marker"
          style={{ left: `${markerPoint.x}%`, top: `${markerPoint.y}%` }}
        >
          <div className="fa-marker-dot" />
        </div>
      )}
    </div>
  );
};

export default AnnotationOverlay;
